import { useState, useEffect } from "react";
import { fetchedClientPortfolio, fetchedUsersByGang } from "../../../apis/apis.dispatches/apisDispatch";
import { fetchedGangs } from "../../../apis/apis.logistics/apisProduct";
import { toast } from "react-toastify";

const currentYear = new Date().getFullYear();
const years = [currentYear - 1, currentYear, currentYear + 1];
const MONTHS = [
    { id: 0,  value: "Enero" },   { id: 1,  value: "Febrero" },
    { id: 2,  value: "Marzo" },   { id: 3,  value: "Abril" },
    { id: 4,  value: "Mayo" },    { id: 5,  value: "Junio" },
    { id: 6,  value: "Julio" },   { id: 7,  value: "Agosto" },
    { id: 8,  value: "Septiembre" }, { id: 9, value: "Octubre" },
    { id: 10, value: "Noviembre" }, { id: 11, value: "Diciembre" },
];

function addMonthsToDate(date, monthsToAdd) {
    const newMonth = date.getMonth() + monthsToAdd;
    const newYear  = date.getFullYear() + Math.floor(newMonth / 12);
    return new Date(newYear, newMonth % 12, date.getDate());
}

const inputCls = "w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors";
const labelCls = "block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-1";
const disabledInputCls = "w-full rounded-lg border border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700/50 text-gray-400 dark:text-gray-500 text-sm px-3 py-2 cursor-not-allowed";

export function ClientPortfolioFilter({ setQuestionState, questionState, setOrders }) {
    const [gangs, setGangs] = useState([]);
    const [users, setUsers] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const getGangs = async () => {
        try { setGangs(await fetchedGangs()); }
        catch (e) { throw e; }
    };
    const getUsersByGang = async (id) => {
        try { setUsers(await fetchedUsersByGang({ gangID: id })); }
        catch (e) { throw e; }
    };

    useEffect(() => { getGangs(); }, []);

    function handleChange(e) {
        const MONTHS_WINDOW = 2;
        if (e.target.name === "startMonth" || e.target.name === "startYear") {
            const year  = e.target.name === "startYear"  ? Number(e.target.value) : Number(questionState.startYear);
            const month = e.target.name === "startMonth" ? Number(e.target.value) : Number(questionState.startMonth);
            const newDate = addMonthsToDate(new Date(year, month), MONTHS_WINDOW);
            setQuestionState({
                ...questionState,
                [e.target.name]: e.target.value,
                endYear:  newDate.getFullYear(),
                endMonth: newDate.getMonth(),
            });
        } else if (e.target.name === "gangID") {
            getUsersByGang(e.target.value);
            setQuestionState({ ...questionState, [e.target.name]: e.target.value });
        } else {
            setQuestionState({ ...questionState, [e.target.name]: e.target.value });
        }
    }

    const handleQuery = async () => {
        if (questionState.startMonth === questionState.endMonth &&
            questionState.startYear  === questionState.endYear) {
            toast.info("Seleccione un rango de meses válido");
            return;
        }
        setIsLoading(true);
        try {
            const res = await fetchedClientPortfolio(questionState);
            setOrders(res);
            const n = res.length;
            toast.info(n > 1 ? `Se encontraron ${n} resultados.` : `Se encontró ${n} resultado(s).`);
        } catch (e) { throw e; }
        finally { setIsLoading(false); }
    };

    const startMonthName = MONTHS[questionState.startMonth]?.value ?? "";
    const endMonthName   = MONTHS[questionState.endMonth]?.value   ?? "";

    return (
        <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm">
            <div className="px-5 py-4 border-b border-gray-200 dark:border-gray-700">
                <h2 className="text-sm font-semibold text-gray-900 dark:text-white flex items-center gap-2">
                    <i className="fas fa-filter text-blue-500"></i>
                    Filtros de búsqueda
                </h2>
            </div>

            <div className="px-5 py-4">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-4 items-end">

                    {/* Rango de inicio */}
                    <div className="lg:col-span-2">
                        <label className={labelCls}><i className="fas fa-calendar-alt mr-1"></i>Año inicio</label>
                        <select name="startYear" value={questionState.startYear} onChange={handleChange} className={inputCls}>
                            {years.map((y) => <option key={y} value={y}>{y}</option>)}
                        </select>
                    </div>
                    <div className="lg:col-span-2">
                        <label className={labelCls}>Mes inicio</label>
                        <select name="startMonth" value={questionState.startMonth} onChange={handleChange} className={inputCls}>
                            {MONTHS.map((m) => <option key={m.id} value={m.id}>{m.value}</option>)}
                        </select>
                    </div>

                    {/* Arrow */}
                    <div className="lg:col-span-1 flex items-end justify-center pb-2">
                        <div className="flex flex-col items-center gap-0.5">
                            <i className="fas fa-arrow-right text-gray-400 dark:text-gray-500"></i>
                            <span className="text-xs text-gray-400 dark:text-gray-500">+2m</span>
                        </div>
                    </div>

                    {/* Rango de fin (calculado automáticamente) */}
                    <div className="lg:col-span-2">
                        <label className={`${labelCls} opacity-50`}>Año fin</label>
                        <select name="endYear" value={questionState.endYear} disabled className={disabledInputCls}>
                            {years.map((y) => <option key={y} value={y}>{y}</option>)}
                        </select>
                    </div>
                    <div className="lg:col-span-2">
                        <label className={`${labelCls} opacity-50`}>Mes fin</label>
                        <select name="endMonth" value={questionState.endMonth} disabled className={disabledInputCls}>
                            {MONTHS.map((m) => <option key={m.id} value={m.id}>{m.value}</option>)}
                        </select>
                    </div>

                    {/* Mes a comparar */}
                    <div className="lg:col-span-1">
                        <label htmlFor="monthToCompare" className={labelCls}>Comparar</label>
                        <select id="monthToCompare" name="monthToCompare" value={questionState.monthToCompare} onChange={handleChange} className={inputCls}>
                            {MONTHS.map((m) => <option key={m.id} value={m.id}>{m.value}</option>)}
                        </select>
                    </div>

                    {/* Ruta */}
                    <div className="lg:col-span-1">
                        <label htmlFor="gangID" className={labelCls}>Ruta</label>
                        <select id="gangID" name="gangID" value={questionState.gangID} onChange={handleChange} className={inputCls}>
                            <option value={0}>Todas</option>
                            {gangs.map((item, i) => <option key={i} value={item.gangID}>{item.gangName}</option>)}
                        </select>
                    </div>

                    {/* Vendedor */}
                    <div className="lg:col-span-2">
                        <label className={labelCls}>Vendedor</label>
                        <select name="userID" value={questionState.userID} onChange={(e) => setQuestionState({ ...questionState, userID: Number(e.target.value) })} className={inputCls}>
                            <option value={0}>Todos</option>
                            {users.map((item, i) => <option key={i} value={item.id}>{item.first_name} | {item.last_name}</option>)}
                        </select>
                    </div>

                    {/* Buscar */}
                    <div className="lg:col-span-1">
                        <button
                            id="btn-filter"
                            onClick={handleQuery}
                            disabled={isLoading}
                            className="w-full inline-flex items-center justify-center gap-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 active:bg-blue-800 disabled:opacity-50 disabled:cursor-not-allowed text-white text-sm font-medium px-4 py-2 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                            {isLoading
                                ? <span className="h-4 w-4 rounded-full border-2 border-white border-t-transparent animate-spin"></span>
                                : <i className="fas fa-search"></i>}
                        </button>
                    </div>
                </div>

                {/* Range indicator */}
                <div className="mt-3 flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
                    <i className="fas fa-info-circle text-blue-400"></i>
                    <span>
                        Rango: <strong className="text-gray-700 dark:text-gray-300">{startMonthName} {questionState.startYear}</strong>
                        {" → "}
                        <strong className="text-gray-700 dark:text-gray-300">{endMonthName} {questionState.endYear}</strong>
                        {" · Comparando con: "}
                        <strong className="text-blue-600 dark:text-blue-400">{MONTHS[questionState.monthToCompare]?.value}</strong>
                    </span>
                </div>
            </div>
        </div>
    );
}
